import { User } from '../types';

/**
 * Check if user has admin privileges
 */
export const isAdmin = (user: User | null): boolean => {
  if (!user) return false;
  return user.role === 'admin' || user.is_superuser === true;
};

/**
 * Check if user is a superuser
 */
export const isSuperuser = (user: User | null): boolean => {
  if (!user) return false;
  return user.is_superuser === true;
};

/**
 * Get user role display name
 */
export const getUserRoleDisplay = (user: User | null): string => {
  if (!user) return 'Guest';

  if (isSuperuser(user)) return 'Super Admin';
  if (user.role === 'admin') return 'Admin';
  return 'Guest';
};

/**
 * Check if user can access admin features
 */
export const canAccessAdmin = (user: User | null): boolean => {
  return isAdmin(user);
};
